// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__367xR","calendarButtons":"ClockData_calendarButtons__4llne"};